export function mantineCssVariablesResolver() {
    return () => ({
        variables: {
            '--mantine-color-body': '#e9e9e9',
            '--mantine-font-family': '"Open Sans", Helvetica, Arial, sans-serif',
            '--mantine-font-size-md': '13px',
        },
        light: {
            '--mantine-color-body': '#e9e9e9',
        },
        dark: {
            '--mantine-color-body': '#e9e9e9',
        },
    });
}
